"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _PulseNotificationMessage = _interopRequireDefault(require("./PulseNotificationMessage"));

var _adobeIntlReact = _interopRequireDefault(require("@adobe/adobe-intl-react"));

var localizationStrings = _interopRequireWildcard(require("./__localization__/PulseNotificationMessageWrapper"));

var _localizationStrings;

var PulseNotificationMessageWrapper =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(PulseNotificationMessageWrapper, _Component);

  function PulseNotificationMessageWrapper() {
    (0, _classCallCheck2.default)(this, PulseNotificationMessageWrapper);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(PulseNotificationMessageWrapper).apply(this, arguments));
  }

  (0, _createClass2.default)(PulseNotificationMessageWrapper, [{
    key: "render",
    value: function render() {
      return _react.default.createElement(_adobeIntlReact.default, {
        locale: this.props.locale,
        localeData: localizationStrings
      }, _react.default.createElement(_PulseNotificationMessage.default, {
        pulseMessageObject: this.props.pulseMessageObject,
        locale: this.props.locale,
        renderCrossButton: this.props.renderCrossButton,
        isFloatingAlert: this.props.isFloatingAlert,
        isReminder: this.props.isReminder,
        showError: false
      }));
    }
  }]);
  return PulseNotificationMessageWrapper;
}(_react.Component);

exports.default = PulseNotificationMessageWrapper;
(0, _defineProperty2.default)(PulseNotificationMessageWrapper, "defaultProps", {
  locale: 'en-US',
  localizationStrings: (_localizationStrings = {
    markAsUnread: "Mark as Unread",
    markAsRead: "Mark as read",
    High: "High",
    Approve: "Approve",
    Reject: "Reject",
    DismissReminder: "Dismiss Reminder",
    DismissAlert: "Dismiss",
    Snooze: "Snooze",
    DeleteReminder: "Delete Reminder",
    EditReminder: "Edit Reminder",
    RemindMeTomorrow: "Remind me tomorrow",
    RemindMe60Min: "Remind me in an hour",
    RemindMe15Min: "Remind me in 15 minutes",
    RemindMe5Min: "Remind me in 5 minutes"
  }, (0, _defineProperty2.default)(_localizationStrings, "DeleteReminder", "Delete Reminder"), (0, _defineProperty2.default)(_localizationStrings, "EditReminder", "Edit Reminder"), _localizationStrings)
});